/* Geometry follows the existing split-pill header; Impact retains disclosure behavior. */
(() => {
  let dispose;
  function bind() {
    if (dispose) dispose();
    const header = document.querySelector('store-header.header');
    const logo = header?.querySelector('.header__logo');
    const nav = header?.querySelector('.header__main-nav');
    if (!header || !logo || !nav) return;
    let frame;
    const measure = () => {
      frame = null;
      if (innerWidth < 1150) return;
      const l = logo.getBoundingClientRect(), n = nav.getBoundingClientRect();
      // The existing grid-spanning pseudo-element extends 20px past both cells.
      const left = Math.max(16, Math.min(l.left, n.left) - 20);
      const right = Math.max(l.right, n.right) + 20;
      const wrapper = header.querySelector('.header__wrapper').getBoundingClientRect();
      const pillHeight = parseFloat(getComputedStyle(header).getPropertyValue('--ss-header-pill-min-height')) * parseFloat(getComputedStyle(document.documentElement).fontSize) || 52;
      const top = Math.max(l.bottom, n.bottom) + Math.max(0, pillHeight - Math.max(l.height, n.height)) / 2 + 8;
      header.style.setProperty('--ss-shop-left', `${left - wrapper.left}px`);
      header.style.setProperty('--ss-shop-width', `${right - left}px`);
      header.style.setProperty('--ss-shop-top', `${top - wrapper.top}px`);
      header.style.setProperty('--ss-shop-viewport-top', `${top}px`);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
    const observer = new ResizeObserver(schedule);
    [header, logo, nav].forEach(el => observer.observe(el));
    addEventListener('scroll', schedule, {passive:true});
    addEventListener('resize', schedule);
    document.fonts.ready.then(schedule);
    measure();
    dispose = () => { observer.disconnect(); cancelAnimationFrame(frame); removeEventListener('scroll',schedule); removeEventListener('resize',schedule); };
  }
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
